import {
  INITIAL_PURSE_NEXT_CHAMPIONSHIP_S5,
  SIDE_BETS_PCT_CHAMPIONSHIP_S5,
} from "@/utils/constants";

/** Ranks 1..30. Sums to the play pool, so scaling is a no-op at full field. */
const PRIZES_CHAMPIONSHIP_S5 = [
  40000, 30000, 25000, 20000, 15000, 12000, 10000, 8000, 7000, 6000, 5508, 5012,
  4561, 4150, 3777, 3437, 3128, 2846, 2590, 2357, 2145, 1952, 1776, 1616, 1471,
  1339, 1218, 1108, 1009, 1000,
];

const MAX_WINNERS = 30;

/** Scales a shape to hit targetTotal exactly, largest remainder first. */
const scalePrizesToTotal = (prizes: number[], targetTotal: number): number[] => {
  const shapeTotal = prizes.reduce((a, b) => a + b, 0);
  if (shapeTotal <= 0 || targetTotal <= 0)
    return new Array(prizes.length).fill(0);

  // Floor then hand out the shortfall by largest remainder, so the result
  // always totals targetTotal exactly — never over, never under.
  const raw = prizes.map((w) => (w * targetTotal) / shapeTotal);
  const base = raw.map((r) => Math.floor(r));

  let need = targetTotal - base.reduce((a, b) => a + b, 0);

  const order = raw
    .map((r, i) => ({ i, frac: r - Math.floor(r) }))
    .sort((a, b) => b.frac - a.frac || a.i - b.i);

  for (let k = 0; need > 0 && k < order.length; k++, need--) base[order[k].i]++;

  return base;
};

/**
 * NEXT Golf Tour Championship, season 5.
 *
 * No entry fee, so the pool is fixed regardless of field size. Ranks 1..30
 * take PRIZES_CHAMPIONSHIP_S5 as-is; a field of N < 30 players is paid ranks
 * 1..N from the same table (matches the finance sheet).
 */
export const prizeCalculatorChampionshipS5 = (
  playersCount: number
): number[] => {
  if (!playersCount || playersCount <= 0) return [];

  const pool = Math.round(
    INITIAL_PURSE_NEXT_CHAMPIONSHIP_S5 * (1 - SIDE_BETS_PCT_CHAMPIONSHIP_S5)
  );

  // The finance sheet uses one fixed table that does not depend on the field
  // size: rank N always gets the same amount. Smaller fields just stop
  // earlier, and the unpaid remainder of the pool is not redistributed.
  const fullTable = scalePrizesToTotal(PRIZES_CHAMPIONSHIP_S5, pool);
  const paidCount = Math.min(playersCount, MAX_WINNERS);
  const prizes = new Array<number>(playersCount).fill(0);
  for (let i = 0; i < paidCount; i++) prizes[i] = fullTable[i];

  return prizes;
};
